import styles from '../InternalExternalDetail.module.css'
import Icon from './Icon'

/**
 * Variants available (match CSS module class names):
 *   primaryBtn, secondaryBtn, heartBtn, menuBtn,
 *   linkBtn, copyBtn, smallIconBtn, docIconBtn
 *
 * Usage examples:
 *   <Button variant="primaryBtn" onClick={fn}>Place a Bid</Button>
 *   <Button variant="linkBtn" icon="download" iconClassName={styles.linkIcon}>Download PDF</Button>
 *   <Button variant="smallIconBtn" icon="edit" />
 */
const Button = ({
  variant,
  icon,
  iconClassName,
  children,
  onClick,
  disabled,
  className,
  type = 'button',
  ...rest
}) => (
  <button
    type={type}
    className={`${styles[variant]}${className ? ` ${className}` : ''}`}
    onClick={onClick}
    disabled={disabled}
    {...rest}
  >
    {icon && <Icon name={icon} className={iconClassName} />}
    {children}
  </button>
)

export default Button
